var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92486 0 0 4.92487 0 11C0 17.0751 4.92486 22 11 22Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44971 16.6181H8.01471V8.73267H5.44971V16.6181ZM15.001 8.82504C14.9739 8.81669 14.9483 8.80729 14.9196 8.79947C14.8851 8.79164 14.8507 8.78485 14.8157 8.77911C14.6795 8.75197 14.5303 8.73267 14.3554 8.73267C12.8598 8.73267 11.9115 9.82024 11.5989 10.2403V8.73267H9.03392V16.6181H11.5989V12.3169C11.5989 12.3169 13.5371 9.61722 14.3554 11.5998C14.3554 13.37 14.3554 16.6176 14.3554 16.6176H16.9194V11.2966C16.9194 10.1057 16.1032 9.11259 15.001 8.82504ZM6.70429 7.65762C7.39733 7.65762 7.95886 7.09606 7.95886 6.40301C7.95886 5.70997 7.39733 5.14844 6.70429 5.14844C6.01177 5.14844 5.44971 5.70997 5.44971 6.40301C5.44971 7.09606 6.01177 7.65762 6.70429 7.65762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdn);
export default __webpack_public_path__ + "static/media/linkdn.2986c34945a7ecfe37d5e5116bb79a29.svg";
export { ForwardRef as ReactComponent };